module.exports = __webpack_public_path__ + "img/image (24).163b2bb6.jpg";